module.exports = __webpack_public_path__ + "img/12.08d41bbc.png";